<template>

    <div class="rendezvous-grid">
        <div class="grid-item">

            <h3 class="steps-header">
                {{getHeading}}
            </h3>

            <div class='providers-grid'>
                <div v-for="obj in getSortedTier1Providers"
                     class='providers-grid-item'
                     :key="obj.providerID"
                     :data-providerID="obj.providerID"
                     @click="handleProviderClick(obj.providerID)">
                    <img :src="getProviderImageSrc(obj)"
                         :alt="obj.providerName">
                </div>
            </div>

            <div :class='getProvidersSelectClass'>
                <CustomSelect
                        :selectConfig="getSelectConfig"
                        @blur="handleBlur"
                        @focus="handleFocus"
                        @input="handleInput">
                </CustomSelect>
            </div>

        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex'
    import CustomSelect from "atoms/CustomSelect";

    export default {
        name: 'TVERendezvousProviders',
        components: {
            CustomSelect
        },
        props: {
            tier1Providers: {
                type: Array,
                required: true,
                default: function () {
                    return []
                }
            },
            tier2Providers: {
                type: Array,
                required: true,
                default: function () {
                    return []
                }
            }
        },
        data: function () {
            return {
                providerID: null,
                customSelectIsOpen: false,
            }
        },
        computed: {

            getHeading() {
                return this.pageAttr.tve_rendezvous_provider_heading
            },

            getSortedTier1Providers() {
                return this.tier1Providers.sort((a, b) => {
                    return a.providerName.toLowerCase().localeCompare(b.providerName.toLowerCase());
                });
            },

            getSelectConfig() {

                let config = {
                    id: 'provider',
                    name: 'provider',
                    wrapperId: 'providers-select',
                    label: this.pageAttr.tve_rendezvous_provider_dropdown_default,
                    selected: '',
                    ref: 'provider',
                    tabIndex: 1,
                    styleClass: [],
                    options: [],
                };

                config.options = this.tier2Providers.map(function (obj) {
                    return {
                        text: obj.providerName,
                        value: obj.providerID
                    }
                });
                config.options = config.options.sort((a, b) => {
                  return a.text.toLowerCase().localeCompare(b.text.toLowerCase())
                })

                return config;
            },

            getProvidersSelectClass() {
                let classList = ['providers-select-wrapper'];
                if (this.customSelectIsOpen) {
                    classList.push('open');
                }
                return classList;
            },

            ...mapState('pageAttributes', {
                pageAttr: state => state.attributes
            }),

        },
        methods: {

            notify() {
                this.$emit('selected', {
                    providerID: this.providerID
                });
            },

            handleProviderClick(providerID) {
                this.providerID = providerID;
                this.notify();
            },

            getProviderImageSrc(obj) {
                return this.$store.getters['cmsImageBaseURL'] + obj.providerLogoBlack;
                //return 'https://test-www.cbs.com/base/' + obj.providerLogoBlack
            },

            handleInput(e) {
                if (e.value) {
                    this.providerID = e.value;
                    this.notify();
                }
            },

            handleFocus() {
                this.customSelectIsOpen = true;
            },

            handleBlur() {
                this.customSelectIsOpen = false;
            },

        },
        watch: {}
    }
</script>
